import styled from 'styled-components'
import Select from 'react-select'
import colors from '@settings/styleSettings'

export const SelectComponent = styled(Select)`
    .Select__control {
        width: 100%;
        border: 1px solid ${(props) => props.borderColor || colors.softGray};
        border-radius: 12px;
        font-size: 16px;
        box-shadow: none;
        cursor: pointer;
        height: ${(props) => props.style.height || '40px'};
        min-width: 125px;
        height: ${(props) => props.height || 40}px;
        &:hover {
            border: 1px solid ${colors.primary};
        }
    }
    .Select__indicator-separator {
        display: none;
    }
    .Select__menu {
        border: 1px solid ${colors.softGray};
        border-radius: 12px;
        box-shadow: none;
        margin-top: 0;
        margin-bottom: 0;
    }
    .Select__option {
        border: none;
        border-radius: 5px;
        cursor: pointer;

        &--is-focused {
            background-color: ${(props) => props.style?.option?.backgroundColor || colors.primary};
            color: ${(props) => props.style?.option?.color || colors.background};
        }
        &--is-selected {
            background-color: ${colors.background};
            color: ${colors.titleStrongBlack};
            &:hover {
                background-color: ${(props) => props.style?.option?.backgroundColor || colors.primary};
                color: ${(props) => props.style?.option?.color || colors.background};
            }
        }
    }
    @media (max-width: 1400px){
        .Select__control {
            font-size: 15px;
        }
        .Select__option {
            font-size: 15px;
        }
    }
    @media (max-width: 340px) {
        .Select__control {
            font-size: 13px;
            width: 112px;
        }
        .Select__option{
            font-size: 13px;
        }
    }
`

export const CustomDropdownIndicator = styled.div`
    color: ${colors.strongGray};
    font-size: 20px;
    margin-right: 10px;
    align-items: center;
    display: flex;
    .material-symbols-outlined {
        font-size: 20px;

    }
    @media (max-width: 1400px){
        font-size: 18px;
        .material-symbols-outlined {
            font-size: 18px;
        }
    }
    @media (max-width: 340px) {
        font-size: 16px;
        .material-symbols-outlined {
            font-size: 16px;
        }
    }

`
export const CustomPlaceholder = styled.div`
    color: ${(props) => props.color || colors.titleStrongBlack};
    display: flex;
    align-items: center;
    justify-content: flex-start;
    align-content: center;
    gap: 5px;
`
export const SearchIcon = styled.div`
  cursor: pointer;
  color: ${colors.strongGray};
`
